module.exports = __webpack_public_path__ + "media/design_video_2.0757b1a9.mp4";